<div class="flex-1 flex flex-col justify-start items-center overflow-hidden w-full h-full">
    <div class="h-full flex-1 w-full overflow-x-auto overflow-y-hidden scrollbar-transparent">
        <div class="flex flex-row h-full gap-4 min-w-max">

            <!-- Waiting For Creators Column -->
            <div
                class="flex flex-col h-full w-80 shrink-0 bg-gray-100 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                <div class="shrink-0 px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                    <div class="flex items-center flex-row gap-x-2">
                        <div
                            class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                            1
                        </div>
                        <div class="">
                            <h3 class="text-sm font-semibold text-primary">Waiting For Creators</h3>
                        </div>
                    </div>
                </div>
                <div
                    class="flex-1 overflow-y-auto p-2 space-y-3 transition-colors duration-200 scrollbar-transparent">
                    @if (notReadyBriefs() && notReadyBriefs().length > 0) {
                    <div class="grid grid-cols-1 gap-y-2">
                        @for (brief of notReadyBriefs(); track $index) {
                        <mon-kanban-card [brief]="brief"></mon-kanban-card>
                        }
                    </div>
                    } @else {
                    <div class="h-full flex items-center justify-center text-gray-400 text-sm">
                        Drop monitoring briefs here
                    </div>
                    }
                </div>
            </div>
            <!-- Waiting For Creators Column - END -->

            <!-- Analysing Screening Brief Column -->
            <div
                class="flex flex-col h-full w-80 shrink-0 bg-gray-100 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                <div class="shrink-0 px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                    <div class="flex items-center flex-row gap-x-2">
                        <div
                            class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                            2
                        </div>
                        <div class="">
                            <h3 class="text-sm font-semibold text-primary">Analysing Screening Brief</h3>
                        </div>
                    </div>
                </div>
                <div
                    class="flex-1 overflow-y-auto p-2 space-y-3 transition-colors duration-200 scrollbar-transparent">
                    @if (processingBriefs() && processingBriefs().length > 0) {
                    <div class="grid grid-cols-1 gap-y-2">
                        @for (brief of processingBriefs(); track $index) {
                        <mon-kanban-card [brief]="brief"></mon-kanban-card>
                        }
                    </div>
                    }
                    @else if (processingBriefs() && processingBriefs().length == 0) {
                    <div class="h-full flex items-center justify-center text-gray-400 text-sm">
                        Drop monitoring briefs here
                    </div>
                    } @else {
                    <div class="w-full h-full flex items-center justify-center">
                        <div class="text-center">
                            <svg class="mx-auto size-16 text-accent" viewBox="0 0 57 60"
                                xmlns="http://www.w3.org/2000/svg" stroke="hsl(228, 97%, 42%)">
                                <g fill="none" fill-rule="evenodd">
                                    <g transform="translate(1 1)" stroke-width="3">
                                        <circle cx="5" cy="50" r="5">
                                            <animate attributeName="cy" begin="0s" dur="2.2s" values="50;5;50;50"
                                                calcMode="linear" repeatCount="indefinite" />
                                            <animate attributeName="cx" begin="0s" dur="2.2s" values="5;27;49;5"
                                                calcMode="linear" repeatCount="indefinite" />
                                        </circle>
                                        <circle cx="27" cy="5" r="5">
                                            <animate attributeName="cy" begin="0s" dur="2.2s" from="5" to="5"
                                                values="5;50;50;5" calcMode="linear" repeatCount="indefinite" />
                                            <animate attributeName="cx" begin="0s" dur="2.2s" from="27" to="27"
                                                values="27;49;5;27" calcMode="linear" repeatCount="indefinite" />
                                        </circle>
                                        <circle cx="49" cy="50" r="5">
                                            <animate attributeName="cy" begin="0s" dur="2.2s" values="50;50;5;50"
                                                calcMode="linear" repeatCount="indefinite" />
                                            <animate attributeName="cx" from="49" to="49" begin="0s" dur="2.2s"
                                                values="49;5;27;49" calcMode="linear" repeatCount="indefinite" />
                                        </circle>
                                    </g>
                                </g>
                            </svg>

                        </div>
                    </div>
                    }
                </div>
            </div>
            <!-- Analysing Screening Brief Column - END -->

            <!-- Refinement Column -->
            <div
                class="flex flex-col h-full w-80 shrink-0 bg-gray-100 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                <div class="shrink-0 px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                    <div class="flex items-center flex-row gap-x-2">
                        <div
                            class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                            3
                        </div>
                        <div class="">
                            <h3 class="text-sm font-semibold text-primary">Refinement</h3>
                        </div>
                    </div>
                </div>
                <div
                    class="flex-1 overflow-y-auto p-2 space-y-3 transition-colors duration-200 scrollbar-transparent">
                    @if (refinementBriefs() && refinementBriefs().length > 0) {
                    <div class="grid grid-cols-1 gap-y-2">
                        @for (brief of refinementBriefs(); track $index) {
                        <mon-kanban-card [brief]="brief"></mon-kanban-card>
                        }
                    </div>
                    } @else if (refinementBriefs() && refinementBriefs().length == 0) {
                    <div class="h-full flex items-center justify-center text-gray-400 text-sm">
                        Drop monitoring briefs here
                    </div>
                    } @else {
                    <div class="w-full h-full flex items-center justify-center">
                        <div class="text-center">
                            <svg class="mx-auto size-16 text-accent" viewBox="0 0 57 60"
                                xmlns="http://www.w3.org/2000/svg" stroke="hsl(228, 97%, 42%)">
                                <g fill="none" fill-rule="evenodd">
                                    <g transform="translate(1 1)" stroke-width="3">
                                        <circle cx="5" cy="50" r="5">
                                            <animate attributeName="cy" begin="0s" dur="2.2s" values="50;5;50;50"
                                                calcMode="linear" repeatCount="indefinite" />
                                            <animate attributeName="cx" begin="0s" dur="2.2s" values="5;27;49;5"
                                                calcMode="linear" repeatCount="indefinite" />
                                        </circle>
                                        <circle cx="27" cy="5" r="5">
                                            <animate attributeName="cy" begin="0s" dur="2.2s" from="5" to="5"
                                                values="5;50;50;5" calcMode="linear" repeatCount="indefinite" />
                                            <animate attributeName="cx" begin="0s" dur="2.2s" from="27" to="27"
                                                values="27;49;5;27" calcMode="linear" repeatCount="indefinite" />
                                        </circle>
                                        <circle cx="49" cy="50" r="5">
                                            <animate attributeName="cy" begin="0s" dur="2.2s" values="50;50;5;50"
                                                calcMode="linear" repeatCount="indefinite" />
                                            <animate attributeName="cx" from="49" to="49" begin="0s" dur="2.2s"
                                                values="49;5;27;49" calcMode="linear" repeatCount="indefinite" />
                                        </circle>
                                    </g>
                                </g>
                            </svg>

                        </div>
                    </div>
                    }
                </div>
            </div>
            <!-- Refinement Column - END -->

            <!-- Monitoring Column -->
            <div
                class="flex flex-col h-full w-80 shrink-0 bg-gray-100 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                <div class="shrink-0 px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                    <div class="flex items-center flex-row gap-x-2">
                        <div
                            class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                            4
                        </div>
                        <div class="">
                            <h3 class="text-sm font-semibold text-primary">Monitoring</h3>
                        </div>
                    </div>
                </div>
                <div
                    class="flex-1 overflow-y-auto p-2 space-y-3 transition-colors duration-200 scrollbar-transparent">
                    @if (monitoringBriefs() && monitoringBriefs().length > 0) {
                    <div class="grid grid-cols-1 gap-y-2">
                        @for (brief of monitoringBriefs(); track $index) {
                        <div>
                            <h2>{{ brief.briefTitle }}</h2>
                        </div>
                        }
                    </div>
                    } @else if (monitoringBriefs() && monitoringBriefs().length == 0) {
                    <div class="h-full flex items-center justify-center text-gray-400 text-sm">
                        Drop monitoring briefs here
                    </div>
                    } @else {
                    <div class="w-full h-full flex items-center justify-center">
                        <div class="text-center">
                            <svg class="mx-auto size-16 text-accent" viewBox="0 0 57 60"
                                xmlns="http://www.w3.org/2000/svg" stroke="hsl(228, 97%, 42%)">
                                <g fill="none" fill-rule="evenodd">
                                    <g transform="translate(1 1)" stroke-width="3">
                                        <circle cx="5" cy="50" r="5">
                                            <animate attributeName="cy" begin="0s" dur="2.2s" values="50;5;50;50"
                                                calcMode="linear" repeatCount="indefinite" />
                                            <animate attributeName="cx" begin="0s" dur="2.2s" values="5;27;49;5"
                                                calcMode="linear" repeatCount="indefinite" />
                                        </circle>
                                        <circle cx="27" cy="5" r="5">
                                            <animate attributeName="cy" begin="0s" dur="2.2s" from="5" to="5"
                                                values="5;50;50;5" calcMode="linear" repeatCount="indefinite" />
                                            <animate attributeName="cx" begin="0s" dur="2.2s" from="27" to="27"
                                                values="27;49;5;27" calcMode="linear" repeatCount="indefinite" />
                                        </circle>
                                        <circle cx="49" cy="50" r="5">
                                            <animate attributeName="cy" begin="0s" dur="2.2s" values="50;50;5;50"
                                                calcMode="linear" repeatCount="indefinite" />
                                            <animate attributeName="cx" from="49" to="49" begin="0s" dur="2.2s"
                                                values="49;5;27;49" calcMode="linear" repeatCount="indefinite" />
                                        </circle>
                                    </g>
                                </g>
                            </svg>

                        </div>
                    </div>
                    }
                </div>
            </div>
            <!-- Monitoring Column - END -->

            <!-- Complete Column -->
            <div
                class="flex flex-col h-full w-80 shrink-0 bg-gray-100 dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700">
                <div class="shrink-0 px-4 py-2 border-b border-gray-200 dark:border-gray-700">
                    <div class="flex items-center flex-row gap-x-2">
                        <div
                            class="shrink-0 size-8 rounded-full bg-gray-50 dark:bg-zinc-800 flex items-center justify-center text-primary">
                            5
                        </div>
                        <div class="">
                            <h3 class="text-sm font-semibold text-primary">Complete</h3>
                        </div>
                    </div>
                </div>
                <div
                    class="flex-1 overflow-y-auto p-2 space-y-3 transition-colors duration-200 scrollbar-transparent">
                    @if (completeBriefs() && completeBriefs().length > 0) {
                    <div class="grid grid-cols-1 gap-y-2">
                        @for (brief of completeBriefs(); track $index) {
                        <mon-kanban-card [brief]="brief"></mon-kanban-card>
                        }
                    </div>
                    }@else if (completeBriefs() && completeBriefs().length == 0) {
                    <div class="h-full flex items-center justify-center text-gray-400 text-sm">
                        Drop monitoring briefs here
                    </div>
                    } @else {
                    <div class="w-full h-full flex items-center justify-center">
                        <div class="text-center">
                            <svg class="mx-auto size-16 text-accent" viewBox="0 0 57 60"
                                xmlns="http://www.w3.org/2000/svg" stroke="hsl(228, 97%, 42%)">
                                <g fill="none" fill-rule="evenodd">
                                    <g transform="translate(1 1)" stroke-width="3">
                                        <circle cx="5" cy="50" r="5">
                                            <animate attributeName="cy" begin="0s" dur="2.2s" values="50;5;50;50"
                                                calcMode="linear" repeatCount="indefinite" />
                                            <animate attributeName="cx" begin="0s" dur="2.2s" values="5;27;49;5"
                                                calcMode="linear" repeatCount="indefinite" />
                                        </circle>
                                        <circle cx="27" cy="5" r="5">
                                            <animate attributeName="cy" begin="0s" dur="2.2s" from="5" to="5"
                                                values="5;50;50;5" calcMode="linear" repeatCount="indefinite" />
                                            <animate attributeName="cx" begin="0s" dur="2.2s" from="27" to="27"
                                                values="27;49;5;27" calcMode="linear" repeatCount="indefinite" />
                                        </circle>
                                        <circle cx="49" cy="50" r="5">
                                            <animate attributeName="cy" begin="0s" dur="2.2s" values="50;50;5;50"
                                                calcMode="linear" repeatCount="indefinite" />
                                            <animate attributeName="cx" from="49" to="49" begin="0s" dur="2.2s"
                                                values="49;5;27;49" calcMode="linear" repeatCount="indefinite" />
                                        </circle>
                                    </g>
                                </g>
                            </svg>

                        </div>
                    </div>
                    }
                </div>
            </div>
            <!-- Complete Column - END -->

        </div>
    </div>
</div>